<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-calendar-plus
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Leave Entitlement"
      text="Leave Entitlement Adjustment"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="localEntitlement.leave_type.name"
                label="Leave Entitlement"
                readonly
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="localEntitlement.employee.person.name"
                class="py-0"
                label="Name"
                readonly
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="adjustedDays"
                v-validate="'required|oneDecimalValue'" 
                :error-messages="errors.collect('adjustedDays')"
                label="Earn / Deduct Days"
                type="number"
                data-vv-name="adjustedDays"
                data-vv-as="earn / deduct days"
                suffix="Day(s)"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-textarea
                v-model="remarks"
                v-validate="'required|max:500'"
                :error-messages="errors.collect('remarks')"
                :rows="3"
                data-vv-name="remarks"                
                label="Remarks"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <helper-file-input
                v-model="file" 
                :max-size-in-mb="2"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"    
                accept-type=".pdf" 
                extension="ext:pdf"     
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    inject: ['$validator'],
    props: {
      entitlement: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        form: null,
        progressing: false,
        localEntitlement: null,
        adjustedDays: 0,
        remarks: null,
        file: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.localEntitlement = { ...this.entitlement }
      },
    },
    mounted () {
      let scope = this

      this.$validator.extend('oneDecimalValue', {
        getMessage (field, args) {
          return 'Only 1 Decimal is allowed'
        },
        validate (value, args) {
          return scope.isValidDecimalNumbers(value)
        },
      })
    },
    methods: {
      isValidDecimalNumbers (value) {
        return (new Big(value).times(100) % 10 === 0)
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.prepareFormData()
            this.$api.leaveEntitlementAdjustments().create(this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                  this.adjustedDays = 0
                  this.remarks = null
                  this.file = null
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('leave_entitlement_id', this.localEntitlement.id)
          this.file.formData.set('adjusted_days', this.adjustedDays)
          this.file.formData.set('remarks', this.remarks)
          return this.file.formData
        }

        let formData = new FormData()
        formData.append('leave_entitlement_id', this.localEntitlement.id)
        formData.append('adjusted_days', this.adjustedDays)
        formData.append('remarks', this.remarks)

        return formData
      },
    },
  }
</script>
